<rt-product-order-header [breadcrumbs]="[]" [header]="header" margin-bottom-large />

<div class="gradient gradient--{{ selectedProductCodename }}"></div>
<rt-box variant="vertical" margin-bottom class="no-radius-top">
  @if (!trial) {
    <rt-heading variant="heading large-x">
      {{ texts.heading | translate }}
    </rt-heading>
    <div text-darkest margin-bottom class="missing-features-sub-header">
      {{ texts.subheading | translate: { planName: selectedProductHumanReadableName } }}
    </div>
  }
  @if (trial) {
    <rt-heading variant="heading large-x">
      {{ texts.headingTrial | translate }}
    </rt-heading>
    <div text-darkest margin-bottom class="missing-features-sub-header">
      {{ texts.subheadingTrial | translate }}
    </div>
  }

  <div class="items">
    @for (
      missingFeature of missingFeatures;
      track trackByIndex(i);
      let i = $index;
      let last = $last
    ) {
      <!-- separator -->
      @if (i > 0 && i % 2 === 0) {
        <div class="break"></div>
      }

      <rt-multilink-downgrade-item
        layout-flex-0-0
        [missingFeature]="missingFeature"
        [trial]="trial"
      />
    }
    @if (trial) {
      <div class="divider-wrapper">
        <rt-divider />
      </div>

      @if (downgradedFeatures.length) {}

      <div class="accordion">
        <div class="accordion__item" [class.accordion__item--expanded]="expandedWhatHappens">
          <div (click)="toggleWhatHappens()" class="accordion__item-header">
            <rt-icon name="chevron-right" />
            {{ texts.accordionHeading | translate }}
          </div>
          @if (expandedWhatHappens) {
            <ng-container [ngTemplateOutlet]="whatHappens" />
          }
        </div>
      </div>
    }
  </div>
</rt-box>

@if (!trial) {
  <rt-box margin-bottom>
    <div class="accordion">
      <div class="accordion__item">
        <rt-heading variant="heading large-x" margin-bottom>
          {{ 'app.pricing.product_order.downgrade.feature_info_heading' | translate }}
        </rt-heading>
        <ng-container [ngTemplateOutlet]="whatHappens" />
      </div>
    </div>
  </rt-box>
}

<rt-box variant="vertical" margin-bottom>
  @if (!trial) {
    <rt-checkbox (click)="toggleConfirmation()" [checked]="confirmed">
      <div
        text-darkest
        [innerHTML]="
          'app.pricing.product_order.downgrade.confirmation'
            | translate
              : {
                  planNameDowngradeTo: selectedProductCodename | titlecase,
                  planNameDowngradeFrom: this.currentProductCode | titlecase,
                  date: formattedDowngradeDate,
                }
        "
      ></div>
    </rt-checkbox>
  }
  @if (trial) {
    <rt-checkbox (click)="toggleConfirmation()" [checked]="confirmed">
      <div text-darkest [innerHTML]="texts.trialConfirmCheckbox | translate"></div>
    </rt-checkbox>
  }
</rt-box>

@if (!trial) {
  <div class="actions">
    <rt-button (click)="cancel()" variant="outline" margin-right-small>
      {{ 'app.pricing.product_order.downgrade.button_keep_features_plan' | translate }}
    </rt-button>

    <rt-button [disabled]="!confirmed" (click)="next()" variant="primary">
      {{ 'app.pricing.product_order.downgrade.button_downgrade' | translate }}
    </rt-button>
  </div>
}

@if (trial) {
  <div class="actions">
    <rt-button (click)="upgrade()" variant="outline" margin-right-small>
      {{ 'app.pricing.product_order.downgrade.button_keep_features' | translate }}
    </rt-button>

    <rt-button [disabled]="!confirmed" (click)="next()" variant="primary">
      {{ 'app.pricing.product_order.downgrade.button_proceed' | translate }}
    </rt-button>
  </div>
}

<ng-template #whatHappens>
  <div class="accordion__item-content">
    <div class="what-happens">
      <div class="what-happens__col">
        @for (item of downgradedFeatures[0]; track trackByIndex($index)) {
          <ng-container *ngTemplateOutlet="featureInfoItem; context: item" />
        }
      </div>
      <div class="what-happens__col">
        @for (item of downgradedFeatures[1]; track trackByIndex($index)) {
          <ng-container *ngTemplateOutlet="featureInfoItem; context: item" />
        }
      </div>
    </div>

    <ng-template #featureInfoItem let-icon="icon" let-title="title" let-desc="description">
      <div
        class="item item--downgraded-feature-info"
        margin-bottom-small
        layout
        layout-flex-0-0
        layout-align-items-start
      >
        <rt-icon
          [name]="icon"
          [hasAutoHeight]="true"
          colorToken="colorIconDefault"
          margin-right-small-x
          padding-top-small-xx
        />
        <div>
          <rt-heading>{{ title | translate }}</rt-heading>
          <p text-small>{{ desc | translate }}</p>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>
